export const QUERY_KEYS = {
  profile: {
    RQKEY_ROOT: 'profile',
  },
  profiles: {
    RQKEY_ROOT: 'profiles',
  },
  linkedAccounts: {
    RQKEY_ROOT: 'linked-accounts',
  },
  actorSearch: {
    RQKEY_ROOT: 'actor-search',
  },
  actorStarterPacks: {
    RQKEY_ROOT: 'actor-starter-packs',
    RQKEY_WITH_MEMBERSHIP_ROOT: 'actor-starter-packs-with-membership',
  },
  list: {
    RQKEY_ROOT: 'list',
  },
  convoList: {
    RQKEY_ROOT: 'convo-list',
  },
  postFeed: {
    RQKEY_ROOT: 'post-feed',
  },
  profileFeedgens: {
    RQKEY_ROOT: 'profile-feedgens',
  },
  profileLists: {
    RQKEY_ROOT: 'profile-lists',
  },
  tenor: {
    RQKEY_ROOT: 'gif-service',
  },
  verificationStatus: {
    RQKEY_ROOT: 'verificationStatus',
  },
} as const
